import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import validationSchema from './ResetPasswordPage.schema';
import { resetPassword } from '../AuthActions';
import CommonButton from '../../common/components/CommonButton';
import RouterPaths from '../../constants/RouterPaths';
import FormInputField, {
  FormInputFieldType,
} from '../../common/components/formFields/FormInputField';
import { CommonButtonVariants } from '../../constants/CommonButtonVariants';
import { useMediaQuery } from '../../common/hooks/useMediaQuery';
import logo from '../../assets/img/logo.png';
import logoMobile from '../../assets/img/icons/logo-mobile.svg';
import authCar from '../../assets/img/tsv-auth-car.png';

const { PRIMARY_RED } = CommonButtonVariants;

const initialValues = {
  password: '',
  passwordRepeat: '',
};

function ResetPasswordPage() {
  const dispatch = useDispatch();
  const { token } = useParams();
  const navigate = useNavigate();

  const isMobile = useMediaQuery('(max-width: 768px)');

  const onSubmitHandler = ({ password, passwordRepeat }, { setSubmitting }) => {
    dispatch(resetPassword({ password, passwordRepeat, token }, () => {})).finally(() => {
      setSubmitting(false);
    });
  };

  const handleSignUpClick = () => {
    navigate(RouterPaths.REGISTER);
  };

  const authLogo = isMobile ? logoMobile : logo;

  return (
    <div className="auth__page">
      <div className="auth__container">
        <div className="auth__credentials-section">
          <div className="auth__header">
            <Link to={RouterPaths.HOMEPAGE} className="auth__logo-link">
              <img src={authLogo} alt="The Stock Vault" className="auth__logo" />
            </Link>
          </div>
          <div className="auth__form-wrapper">
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmitHandler}
              validationSchema={validationSchema}
            >
              {() => (
                <Form className="auth__form">
                  <h3 className="auth__heading">Reset password</h3>
                  <p className="auth__reset-description">
                    Enter and confirm your new password to complete the reset.
                  </p>
                  <FormInputField
                    labelVariant="bordered"
                    inputClassName="auth__login-input-field"
                    wrapperClassName="auth__login-input-wrapper"
                    name="password"
                    type={FormInputFieldType.PASSWORD}
                    label="Password"
                    required
                    aria-describedby="password-error"
                  />
                  <FormInputField
                    labelVariant="bordered"
                    inputClassName="auth__login-input-field"
                    wrapperClassName="auth__login-input-wrapper"
                    name="passwordRepeat"
                    type={FormInputFieldType.PASSWORD}
                    label="Repeat Password"
                    required
                    aria-describedby="repeat-password-error"
                  />
                  <CommonButton
                    type="submit"
                    label="Reset Password"
                    className="auth__reset-password-button"
                    variant={PRIMARY_RED}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <div className="auth__banner-section">
          <div className="auth__banner-content">
            <h2 className="auth__banner-header">Want to sell the stock too?</h2>
            <h5 className="auth__banner-description">
              If you’re a franchised dealer, you can sign up today to list your stock.
            </h5>
            <CommonButton
              type="button"
              label="Sign Up"
              className="auth__sign-up-button"
              size="large"
              variant={PRIMARY_RED}
              handleClick={handleSignUpClick}
            />
          </div>
          <div className="auth__banner-image">
            <img src={authCar} alt="The Stock Vault Car" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
